import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import FlowManager from 'components/FlowManager'

import { getCustomerSegment } from 'modules/billing/selectors'

import config from 'config'
import { track } from 'utils/trackingUtils'

import DealOnboardingFlowRoutes from './routes'

import { api } from 'modules/org/api'
import { fetchEmbedSuccess, fetchEmbedFailed } from 'modules/org/actions'

import './style.css'

const mapStateToProps = (state) => {
  return {
    customerSegment: getCustomerSegment(state)
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchEmbedSuccess,
    fetchEmbedFailed
  }, dispatch),
})

class DealOnboardingFlow extends PureComponent {
  state = {
    done: false,
  }

  componentDidMount() {
    this.fetchOrgEmbed()
    track('Embedded Onboarding - Viewed', {pageTitle: "Welcome to Drift!"})
  }

  fetchOrgEmbed = () => {
    const { actions } = this.props

    api.fetchEmbed()
      .then((response) => actions.fetchEmbedSuccess(response))
      .catch((err) => actions.fetchEmbedFailed(err))
  }

  onDone = () => {
    window.location.replace(config.CUSTOMER_WEB_URL)
  }

  render() {
    const { match, history } = this.props

    return (
      <div className="embedded-onboarding-flow--root">
        <FlowManager steps={DealOnboardingFlowRoutes} baseUrl={match.url} history={history} onDone={this.onDone} name='Embedded Onboarding'/>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DealOnboardingFlow)



// WEBPACK FOOTER //
// ./src/flows/DealOnboardingFlow/index.js